import Facet from "../../types/funnelback/Facets";
import composeFieldName from "./composeFieldName";

export const getFacetParamKey = (facet: Facet): string => {
    const { categories } = facet;
    if (!categories || !categories.length) {
        return "";
    }
    return categories[0].queryStringParamName;
};

export const getFieldNameFromFacetParamKey = (
    facetParamKey: string
): string => {
    const facetFieldKey = composeFieldName(facetParamKey);
    switch (facetFieldKey) {
        case "d":
            return "datePublished";
        default:
            return facetFieldKey;
    }
};

export const findFacetByFieldName = (
    fieldName: string,
    facets: Facet[]
): Facet | null => {
    if (!facets.length) {
        return null;
    }

    const matchingFacet = facets.find((facet) => {
        const { categories } = facet;
        if (!categories || !categories.length) {
            return false;
        }
        const facetParamKey = categories[0].queryStringParamName;
        const facetFieldName = getFieldNameFromFacetParamKey(facetParamKey);
        return facetFieldName === fieldName;
    });
    return matchingFacet ? matchingFacet : null;
};

const findFacetByParamKey = (
    paramKey: string,
    facets: Facet[]
): Facet | null => {
    if (!facets.length) {
        return null;
    }
    const matchingFacet = facets.find((facet) => {
        const { categories } = facet;
        return (
            categories &&
            categories.length &&
            categories[0].queryStringParamName === paramKey
        );
    });
    return matchingFacet ? matchingFacet : null;
};

export default findFacetByParamKey;
